import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  createSelector,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { LdTeam } from 'types/store/normalized/ldTeam';

const ldTeamsAdapter = createEntityAdapter<LdTeam>();
const initialState = ldTeamsAdapter.getInitialState();

const ldTeamsSlice = createSlice({
  name: 'projectsList/include/ldTeams',
  initialState,
  reducers: {
    updateLdTeams: (
      state,
      action: PayloadAction<{
        ldTeams: LdTeam[];
        shouldReplace: boolean;
      }>
    ) => {
      const { ldTeams, shouldReplace } = action.payload;
      if (shouldReplace) {
        ldTeamsAdapter.setAll(state, ldTeams);
      } else {
        ldTeamsAdapter.upsertMany(state, ldTeams);
      }
    },
    removeAllLdTeams: (state) => {
      ldTeamsAdapter.removeAll(state);
    },
  },
});

export const { updateLdTeams, removeAllLdTeams } = ldTeamsSlice.actions;

const selectLdTeams = (state: RootState) => state.projectsList.include.ldTeams;

export const { selectAll: selectAllLdTeams } =
  ldTeamsAdapter.getSelectors<RootState>(selectLdTeams);

export const selectLdTeamsById = createSelector(
  [selectAllLdTeams, (_, ldTeams: string[]) => ldTeams],
  (ldTeams, ldTeamsIds) => {
    return ldTeams.filter((ldTeam) => ldTeamsIds.includes(ldTeam.id));
  }
);

export default ldTeamsSlice.reducer;
